'use strict';

import Dexie from "dexie";

/**
 * Module SERVICES
 */
angular.module('services')
	.factory('DexieDatabaseService', function () {

		/** Gestion de la base de donnée locale **/
		var dbs = [];

		function getDb(referential) {

			referential = referential || "Okina";
			var db = dbs[referential];

			if (db === undefined || db === null) {
				Dexie.delete("OkinaNetwork");
				db = new Dexie(referential);
				db.version(1).stores({
					network: "++id, [networkId+name], lastModified",
					line: "id, networkId, name",
					cities: "++id, cityId, cityIdRef, schemaName, color, geoJSON, name"
				});
				db.getNetwork = function (network) {
					return db.network.get({"[networkId+name]": [network.id, network.name]});
				};
				db.getLines = function (network) {
					return db.line.where('networkId').equals(network.id).sortBy('name');
				};
				db.getCities = function (schemaName) {
					return db.cities.where('schemaName').equals(schemaName).toArray();
				};
				db.deleteLine = function (network, line)  {
					return db.line.delete(line.id);
				}
			}
			dbs[referential] = db;
			return db;
		}

		// PUBLIC API
		return {
			getDb: getDb
		};

	}

	)
;


